import { Link } from "react-router-dom";
import type { PlayerReport } from "../../../api/playerReports";
import { EvidenceLinks } from "./EvidenceLinks";

export function PracticeEvidence({ data }: { data: PlayerReport }) {
  const p = data.evidence.practice;
  const passing = data.performance.some((v) =>
    ["pases", "passing"].includes(v.scenario),
  );
  const progress = data.reading.progress;
  const comp = progress.comparison;
  return (
    <div className="report-practice-evidence">
      {passing && p.skills.some((s) => s.total > 0) && (
        <>
          <h3>Decisiones y ejecución</h3>
          <div className="report-profile-grid">
            {p.skills
              .filter((s) => s.total > 0)
              .map((s) => (
                <article className="report-profile-card" key={s.key}>
                  <h3>{s.title}</h3>
                  <p className="report-profile-value">
                    {s.total ? `${s.successes}/${s.total}` : "—"}
                  </p>
                  <p>
                    {s.total
                      ? "resueltos correctamente"
                      : "Sin intentos con evidencia suficiente"}
                  </p>
                  <details className="report-row-context">
                    <summary>Cómo se cuenta</summary>
                    <p className="report-caption">{s.note}</p>
                  </details>
                  <EvidenceLinks refs={s.evidence} />
                </article>
              ))}
          </div>
        </>
      )}
      {p.timing.length > 0 && (
        <details className="report-disclosure">
          <summary>Cómo usaste el tiempo disponible</summary>
          <p className="report-caption">
            Ejecuciones agrupadas por ejercicio y plazo; el mismo plazo no
            garantiza la misma dificultad. La mediana describe el intento
            central; tiempos menores no implican mejores decisiones. Los casos
            sin ejecución y las esperas correctas quedan fuera.
          </p>
          <div className="report-table-scroll">
            <table>
              <thead>
                <tr>
                  <th>Ejercicio</th>
                  <th>Plazo</th>
                  <th>Tiempo mediano</th>
                  <th>Aciertos</th>
                </tr>
              </thead>
              <tbody>
                {p.timing.map((t, i) => (
                  <tr key={i}>
                    <td>{t.exercise}</td>
                    <td>{t.deadline_s} s</td>
                    <td>{t.median_response_s} s</td>
                    <td>
                      {t.successes}/{t.count}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </details>
      )}
      {p.after_error.total > 0 && (
        <div className="report-panel">
          <h3>La siguiente jugada después de un error</h3>
          <p>
            <strong>
              {p.after_error.successes} de {p.after_error.total}
            </strong>{" "}
            se resolvieron correctamente.
          </p>
          <p className="report-caption">{p.after_error.note}</p>
          <EvidenceLinks refs={p.after_error.evidence} />
        </div>
      )}
      {data.scope !== "trial" && (
        <div className="report-panel">
          <h3>Del comienzo al cierre</h3>
          <p>{progress.summary}</p>
          {comp && (
            <>
              <div className="report-progress-bars">
                {[
                  {
                    label: "Comienzo",
                    value: comp.first,
                    trials: comp.first_trials,
                  },
                  {
                    label: "Cierre",
                    value: comp.last,
                    trials: comp.last_trials,
                  },
                ].map((t) => (
                  <div key={t.label}>
                    <span>{t.label}</span>
                    <div className="report-progress-track">
                      <span style={{ width: `${(100 * t.value) / comp.n}%` }} />
                    </div>
                    <strong>
                      {t.value}/{comp.n}
                    </strong>
                    <small>Jugadas {t.trials.join(", ")}</small>
                  </div>
                ))}
              </div>
              <p className="report-caption">
                {comp.included} de {comp.total} jugadas incluidas.
              </p>
            </>
          )}
          <p className="report-caption">{progress.note}</p>
          {data.scope === "global" && progress.session_id && (
            <Link
              to={`/data/reports/sessions/${encodeURIComponent(progress.session_id)}`}
            >
              Revisar esa sesión →
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
